import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@ui/button';
import { PillText } from '@web/atoms';
import { ResponsiveImage, CtaShell } from '@web/molecules';
import {
  Container,
  Header,
  HeaderImage,
  HeaderBadge,
  Content,
  ContentCallout,
  ContentBenefit,
  ContentDescription,
  Footer,
  FooterButton,
} from './styles';

export const ProductValues = ({
  callout,
  benefit,
  badge,
  badgeVariant = 'dark',
  badgeIcon,
  badgeIconAlignment = 'left',
  description,
  image,
  link,
  buttonVariant = 'primary',
}) => {
  return (
    <Container>
      <Header>
        {image?.src && (
          <HeaderImage>
            <ResponsiveImage {...image} />
          </HeaderImage>
        )}
        {badge && (
          <HeaderBadge>
            <PillText
              text={badge}
              variant={badgeVariant}
              icon={badgeIcon}
              iconAlignment={badgeIconAlignment}
            />
          </HeaderBadge>
        )}
      </Header>
      <Content>
        {callout && <ContentCallout>{callout}</ContentCallout>}
        <ContentBenefit>{benefit}</ContentBenefit>
        {description && <ContentDescription>{description}</ContentDescription>}
      </Content>
      {link && (
        <Footer>
          <FooterButton>
            <CtaShell
              fullWidth={link.fullWidth}
              fullWidthMobile={link.fullWidthMobile}
              fullWidthDesktop={link.fullWidthDesktop}
              sideMargin={link.sideMargin}
            >
              <LinkButton
                href={link.target}
                variant={buttonVariant}
                headerText={link.headerText}
                fullWidth={link.fullWidth}
                fullWidthMobile={link.fullWidthMobile}
                fullWidthDesktop={link.fullWidthDesktop}
              >
                {link.text}
              </LinkButton>
            </CtaShell>
          </FooterButton>
        </Footer>
      )}
    </Container>
  );
};

ProductValues.displayName = 'ProductValues';

ProductValues.propTypes = {
  callout: PropTypes.string,
  benefit: PropTypes.string.isRequired,
  badge: PropTypes.string,
  badgeVariant: PropTypes.string,
  badgeIcon: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  badgeIconAlignment: PropTypes.oneOf(['left', 'right']),
  description: PropTypes.node,
  image: PropTypes.object,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
  buttonVariant: PropTypes.string,
};
